import Images from "../Assets";

export const data = [
  {
    id: 1,
    firstParagraph: "Save up to $39.99",
    headLine1: "PlayStation 5",
    secondParagraph:
      "Lightning-fast download speed with super-fast SSD storage",
    background: Images.Img1,
  },
  {
    id: 2,
    firstParagraph: "Save up to $49.99",
    headLine1: "APPLE AIRPODS",
    secondParagraph: "AirPods are the best-selling headphones in the world",
    background: Images.Img44,
  },
  {
    id: 3,
    firstParagraph: "Save up to $99.99",
    headLine1: "iPhone 11 PRO",
    secondParagraph: "Pro cameras.Pro display. Pro performance.",
    background: Images.Img88,
  },
];
